/**
 *
 * check if given element is in viewpot
 * @param elem - element to check
 *
 * @returns return true if is in viewport
 */
export const isInViewport = (elem) => {
    const bounding = elem.getBoundingClientRect();
    return (bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
};
export const scrollToPx = (endPosition) => {
    if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
            top: endPosition,
            left: 0,
            behavior: 'smooth',
        });
    }
    else {
        let gap = window.scrollY;
        const direction = gap > endPosition ? 'up' : 'down';
        const int = setInterval(function () {
            if (direction === 'up') {
                gap -= 10;
                if (gap <= endPosition)
                    clearInterval(int);
            }
            else {
                gap += 10;
                if (gap >= endPosition)
                    clearInterval(int);
            }
            window.scrollTo(0, gap);
        }, 10);
    }
};
// for PLP tiles check
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const findDuplicates = () => {
    const tiles = new Map();
    document.querySelectorAll('[data-id]').forEach((tile) => {
        // @ts-ignore
        let currentId = tile.dataset.id;
        if (tiles.has(currentId)) {
            tiles.set(currentId, Number(tiles.get(currentId)) + 1);
        }
        else {
            tiles.set(currentId, 1);
        }
    });
    let duplicateCounter = 0;
    for (const [key, value] of tiles) {
        if (value > 1) {
            duplicateCounter++;
            console.info(`found ${value} duplicates for ${key}`);
        }
    }
    console.info(`%cfound a total of ${duplicateCounter} duplicates!`, 'color:purple;background-color:white;font-weight:bold;');
};
